import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-datepicker', 'chooseDate', 'Izvēlieties datumu');
Labels.set('ui-datepicker', 'selectedDate', 'Atlasītais datums');
Labels.set('ui-datepicker', 'close', 'Aizvērt');
Labels.set('ui-datepicker', 'clear', 'Notīrīt ievadi');
